import React from 'react';
import PageFrame from './PageFrame';
import PageToolbar from './PageToolbar';
import StatCardRow from './StatCard';
import resolveTemplateHeader, { mergeFamilyHeaderChrome } from './resolveTemplateHeader';
import { ShellChromeProvider } from './ShellChromeContext';

/**
 * ListPageTemplate — toolbar + optional stats + filters + content.
 */
const ListPageTemplate = ({
  children,
  className = '',
  dir,
  wide = false,
  header,
  familyHeader,
  title,
  subtitle,
  headerActions,
  toolbar,
  contextFilters,
  embedFiltersInToolbar = true,
  stats,
  filters,
  content,
}) => {
  const inlineToolbarFilters =
    contextFilters ??
    (embedFiltersInToolbar !== false && familyHeader ? filters : undefined);
  const mergedFamilyHeader = mergeFamilyHeaderChrome(familyHeader, {
    toolbar,
    filters: inlineToolbarFilters,
  });
  const resolvedHeader = resolveTemplateHeader({
    header,
    familyHeader: mergedFamilyHeader,
    title,
    subtitle,
    headerActions,
  });

  return (
    <ShellChromeProvider titleOwned={Boolean(familyHeader)}>
      <PageFrame className={`ads-screen-list ${className}`.trim()} dir={dir} wide={wide}>
        {resolvedHeader}
        {toolbar && !familyHeader ? <PageToolbar>{toolbar}</PageToolbar> : null}
        {stats ? <StatCardRow>{stats}</StatCardRow> : null}
        {filters && (!familyHeader || contextFilters != null || embedFiltersInToolbar === false)
          ? filters
          : null}
        {content ?? children}
      </PageFrame>
    </ShellChromeProvider>
  );
};

export default ListPageTemplate;
